module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/205/assets/images/76e91e4c1a2bd3cd89e1f2a090b3281c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_tick.svg
// module id = kpGz
// module chunks = 1